import { render } from "./PaymentPage.vue?vue&type=template&id=3f77970e"
import script from "./PaymentPage.vue?vue&type=script&lang=js"
export * from "./PaymentPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/corpsales-services/corpsales-services/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__